import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavbarComponent from './components/NavbarComponent';
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Quote from "./pages/Quote";
import Login from "./pages/Login";
import Footer from "./components/Footer";
import ServiceDetails from "./components/ServiceDetails";
import TeamSection from "./pages/TeamSection";
import { FloatingWhatsApp } from 'react-floating-whatsapp';

function App() {
    return (
        <Router>
            <div style={{ position: 'relative', zIndex: '1' }}>
                <NavbarComponent />
            </div>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/team" element={<TeamSection />} />
                <Route path="/service/:serviceId" element={<ServiceDetails />} />
                <Route path="/home" element={<Navigate replace to="/" />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
            <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: '9999' }}>
                <FloatingWhatsApp
                    phoneNumber="+923183561921"
                    accountName="Anam Sarwar"
                    allowEsc={true}
                    allowClickAway={true}
                    notification={true}
                    notificationSound={true}
                    style={{ pointerEvents: 'auto' }} // Re-enable pointer events
                />
            </div>
         <Footer/>
        </Router>
    );
}

export default App;
